import { render, staticRenderFns } from "./LayoutPreview.vue?vue&type=template&id=bc45a43a&"
import script from "./LayoutPreview.vue?vue&type=script&lang=js&"
export * from "./LayoutPreview.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPreview.vue?vue&type=style&index=0&id=bc45a43a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports